import Icon from '../components/Icon.vue'

Icon.register({
  'vector-square': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 128c0 17.7-14.3 32-32 32v192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32h-192c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32v-192c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32h192c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96zM416 64v32h32v-32h-32zM64 64v32h32v-32h-32zM96 448v-32h-32v32h32zM448 448v-32h-32v32h32zM416 352v-192h-32c-17.7 0-32-14.3-32-32v-32h-192v32c0 17.7-14.3 32-32 32h-32v192h32c17.7 0 32 14.3 32 32v32h192v-32c0-17.7 14.3-32 32-32h32z'
      }
    ]
  }
})
